import AtomSearchInput from '@/components/Atoms/AtomSearchInput/AtomSearchInput'

import type { ContractsFilters as ContractsFiltersValue } from '../types/contracts.types'
import cn from './ContractsFilters.module.scss'

type ContractsFiltersProps = {
  value: ContractsFiltersValue
  onChange: (value: ContractsFiltersValue) => void
  isOrganisationSelected: boolean
}

function ContractsFilters({
  value,
  onChange,
  isOrganisationSelected,
}: ContractsFiltersProps) {
  return (
    <div className={cn.filters}>
      <AtomSearchInput
        className={cn.search}
        placeholder="Поиск по наименованию"
        aria-label="Поиск по наименованию"
        value={value.description}
        onChange={(event) =>
          onChange({ ...value, description: event.target.value })
        }
        isOrganisationSelected={isOrganisationSelected}
      />
      <AtomSearchInput
        className={cn.search}
        placeholder="Поиск по номеру договора"
        aria-label="Поиск по номеру договора"
        value={value.number}
        onChange={(event) => onChange({ ...value, number: event.target.value })}
        isOrganisationSelected={isOrganisationSelected}
      />
    </div>
  )
}

export default ContractsFilters
